/* eslint-disable import/prefer-default-export */
export const defaultRights = {
    create: false,
    read: false,
    update: false,
    delete: false,
};
